var React = require('react');

function MagnifyingGlass (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(0.000000, -6.000000)","stroke":"currentColor","strokeWidth":"2"},React.createElement("g",null,React.createElement("g",{"transform":"translate(0.000000, 6.000000)"},[React.createElement("circle",{"cx":"6","cy":"6","r":"5","key":0}),React.createElement("path",{"d":"M10,10 L15,15","strokeLinecap":"round","key":1})])))));
}

MagnifyingGlass.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 16 16","version":"1.1"};

module.exports = MagnifyingGlass;

MagnifyingGlass.default = MagnifyingGlass;
